const getLogger = require('./logger')

const logger = getLogger()

const errors = {
  400: body => ({
    code: 'HTTP-400',
    title: 'Invalid request.',
    detail: body || 'Bad Request',
  }),
  401: body => ({
    code: 'HTTP-401',
    title: 'Unauthorized access.',
    detail: body || 'You may need to login to access this resource.',
  }),
  403: body => ({
    code: 'HTTP-403',
    title: 'No permission.',
    detail: body || 'You do not have sufficient permissions to access this resource.',
  }),
  404: body => ({
    code: 'HTTP-404',
    title: 'Resource not found.',
    detail:
      body || 'The resource either never existed, or may have been deleted.',
  }),
  409: body => ({
    code: 'HTTP-409',
    title: 'Conflict.',
    detail: body || 'The request could not be completed due to a conflict with the current state of the target resource.',
  }),
  500: () => ({
    code: 'HTTP-500',
    title: 'Internal error.',
    detail: 'Internal server error. Please check Logs.',
  }),
}

const sendError = (res, input) => {
  logger.error(
    input instanceof Error || typeof input === 'object'
      ? JSON.stringify(input, Object.getOwnPropertyNames(input))
      : input
  )
  let code = 400
  let body
  switch (typeof input) {
    case 'number':
      if (errors[input]) code = input
      break
    case 'string':
      body = input
      break
    default:
      // Error already handled by other service
      if (input.status) {
        const { status, ...restError } = input
        code = status
        if (restError instanceof Error) body = ''
        else
          body = restError.error.error
            ? restError.error.error
            : restError.error
            ? restError.error
            : restError
        break
      } else if (input instanceof Error && errors[input.code]) {
        code = input.code
        body = errors[input.code]()
        break
      }
      code = 500
      body = 'Internal server error. Please check Logs.'
      break
  }
  res.status(code).json({
    error: body,
    errors: [errors[code](body)],
  })
}

module.exports = sendError
